<template>
  <div class="page page-roadshow-list">
    <a-tabs type="card" defaultActiveKey="report" @change="onTabChange">
      <a-tab-pane :tab="item.name" v-for="item in tabs" :key="item.key"></a-tab-pane>
    </a-tabs>
    <div class="list-options v-mt-sm">
      <a-form layout="inline" class="options-form">
        <a-row :gutter="24">
          <a-col span="8">
            <a-form-item :colon="false" label="项目类型">
              <a-select allow-clear placeholder="请选择" v-model="form.ptype" style="width: 200px" ref="ptype">
                <a-select-option :value="21">螺蛳壳改造</a-select-option>
                <a-select-option :value="22">精灵书屋</a-select-option>
                <a-select-option :value="23">公益人才</a-select-option>
                <a-select-option :value="24">爱心100</a-select-option>
                <a-select-option :value="25">其他项目</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="报告类型">
              <a-select allow-clear placeholder="请选择" v-model="form.type" style="width: 200px" ref="type">
                <a-select-option :value="5">年报（审计）</a-select-option>
                <a-select-option :value="6">项目总结报告</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="flex items-center v-my-sm">
      <div class="v-ml-auto">
        <a-space>
          <a-button icon="search" type="primary" size="small" @click="handleSearch">查询</a-button>
          <a-button icon="plus" type="indigo" size="small" @click="$router.push('draft')" v-hasPermission="['project:own:report:draft']">新增项目报告</a-button>
          <!-- <a-button icon="file-excel" type="indigo" size="small" @click="exportData">导出</a-button> -->
        </a-space>
      </div>
    </div>
    <div class="list-table-container">
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
      <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :data-source="list" :scroll="{ x: '100%' }" rowKey="id">
        <a-table-column title="#" data-index="index" :width="60" align="center">
          <template slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="报告名称" :ellipsis="true" data-index="reportName" align="left">
          <template slot-scope="text, record">
            <!-- <router-link :to="{ path: '../report-detail', query: { id: record.projectId, rid: record.reportId } }" class="text-indigo hover-line" :title="record.reportName">{{ record.reportName }}</router-link> -->
            {{ record.reportName }}
          </template>
        </a-table-column>
        <a-table-column title="报告类型" data-index="type" align="left">
          <template slot-scope="text, record">
            <a-tag color="purple" v-if="record.type == 5">年报（审计）</a-tag>
            <a-tag color="purple" v-else-if="record.type == 6">项目总结报告</a-tag>
          </template>
        </a-table-column>
        <a-table-column title="报告提交人" :width="200" data-index="creatorName" align="left" />
        <a-table-column title="创建/提交时间" :width="200" data-index="createTime" align="left">
          <template slot-scope="text, record">
            <template>{{ record.submitTime ? record.submitTime.substring(0, 16) : record.createTime.substring(0, 16) }}</template>
          </template>
        </a-table-column>
        <a-table-column title="状态" :width="120" data-index="quantity" align="left">
          <template slot-scope="text, record">
            <span class="text-red" v-if="record.state == 0">待提交<template v-if="record.checkResult == -1">(被驳回)</template></span>
            <span v-else-if="record.state == 9">已提交</span>
            <span class="text-red" v-else>待审核</span>
          </template>
        </a-table-column>
        <a-table-column title="操作" data-index="amount" :width="80" align="center">
          <template slot-scope="text, record">
            <a-space :size="10">
              <template v-if="record.state === 0">
                <span class="font-xs hover-line text-indigo" title="修改" @click="$router.push(`./draft?rid=${record.reportId}`)">修改</span>
                <span class="font-xs hover-line text-red" title="删除" @click="handleDel(record.reportId)">删除</span>
              </template>
              <template v-else-if="isProcessable(record.state)">
                <span class="font-xs hover-line text-indigo" title="处理" @click="$router.push(`./review?&rid=${record.reportId}`)">处理</span>
              </template>
              <span class="font-xs hover-line text-indigo" title="查看" @click="$router.push(`./detail?rid=${record.reportId}`)" v-else>查看</span>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const form = {
  ptype: undefined,
  type: undefined,
}
import { listSummaryReport, delReport } from '@/api/project/common'
export default {
  data() {
    return {
      loading: false,
      list: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      form: { ...form },
      tabs: [],
    }
  },
  watch: {
    tab() {
      this.form = { ...form }
      this.load()
    },
  },
  methods: {
    initTabs() {
      let currentRoute = this.$utils.getCurrentRoute(this.menuRoutes, '/project/main')
      let tabs = (currentRoute && currentRoute.children) || []
      this.tabs = tabs.filter(tab => tab.path)
    },
    onTabChange(key) {
      this.$router.push(`/project/main/${key}/list`)
    },
    handleSearch() {
      this.load()
    },
    load(page = 1, pageSize = 10, sorter) {
      this.loading = true
      let params = {
        page,
        pageSize,
        sorter,
        ptypes: [21, 22, 23, 24, 25],
        ...this.form,
      }
      listSummaryReport(params)
        .then(({ data }) => {
          if (data.success) {
            let { current, size, total, records } = data.result
            this.list = records
            this.pagination = {
              page: current,
              pageSize: size,
              total,
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onPageChange(page, pageSize) {
      this.load(page, pageSize)
    },
    handleDel(reportId) {
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          // 异步关闭
          return new Promise((resolve, reject) => {
            delReport(reportId, this.projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.load()
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          })
        },
      })
    },
  },
  created() {
    this.initTabs()
    this.load()
  },
}
</script>
